module.exports = __webpack_public_path__ + "static/3-144ee5766c7601ff7ff042916bbc24d6.jpeg";